import React, { useState, useEffect } from 'react';
import EnterAmount from './components/EnterAmount/EnterAmount';
import CalculationSection from './components/CalculationSection/CalculationSection';
import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import { useHistory } from 'react-router-dom';
import { fetcher } from 'app/http';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import { setContent } from 'features/content/reducer';
import styles from './EnterDisposableIncomePageData.module.scss';
import WizardSteps from 'components/WizardSteps/WizardStepsSection';
import http from 'app/http';
import PageLink from 'components/PageLink/PageLink';
import { getGTMVariables, getGTMVariablesPageView  } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const EnterDisposableIncomePageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const history = useHistory();
  const dispatch = useAppDispatch();

  const [collapseCalculation, setCollapseCalculation] = useState(false);

  const setValue = (param: any) => {
    setCollapseCalculation(param);
  };
  const [incomeAmountCalculation, setIncomeAmountCalculation] = useState();
  const incomeAmountForCalculation= (param:any) =>{
    setIncomeAmountCalculation(param);
  }

  const getCurrencyClass = ()=>{
    var currencyClass = "Icon-euro--before";

    if (Model.DisplayedCurrency === 'PLN')
    {
        currencyClass = "Icon-zt--before";
    }
    else if (Model.DisplayedCurrency === 'GBP')
    {
        currencyClass = "Icon-ps--before";
    }
    return currencyClass;
  }

  const [disposableIncomeAmount, setDisposableIncomeAmount] = useState();
  const disposableIncome= (param:any) =>{
    setDisposableIncomeAmount(param);
  }


  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);
    return link.pathname + link.search;
};

  const formSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response =(typeof(incomeAmountCalculation) === 'undefined' && typeof(disposableIncomeAmount) === 'undefined') ?
      await http.post(
        Model?.PostDisposableIncomePageUrl,
        qs.stringify({
          'FormModel.DisposableIncome': Model?.FormModel.DisposableIncome,
        })
      ):
      await http.post(
        Model?.PostDisposableIncomePageUrl,
        qs.stringify({
          'FormModel.DisposableIncome': incomeAmountCalculation? incomeAmountCalculation : disposableIncomeAmount,
        })
      );
      if (response && response.data) {
        let nextPagePath = '';
        if (!response.data.RedirectUrl) {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        }
        history.push(nextPagePath, {
          noRefresh: false,
        });
      }
    }
    catch (err) {
        console.error(err);
    }
};

useEffect(() => {
  if (LayoutModel != undefined) {
    var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
    var isLoggedIn = LayoutModel?.HasProfile;
    var lang = PageData?.Language;
    var env = LayoutModel?.Environment;
    var reg = LayoutModel?.CountryCode;
    getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
    getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
  }
}
  , [LayoutModel]);


  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
      <form onSubmit={formSubmit}>
        <h1 className="Heading">
          {Model?.PageDataBase.HeaderForIncomeCalculator}
        </h1>
        {!Model.IsUpdate && (
               <WizardSteps activeWizardStep={Model.ActiveWizardStep} wizardLabels={Model?.WizardLabels}/>
        )
        }
        <ChangePlanHeader Headingtext={PageData?.Heading} />

        <EnterAmount showCalculation={collapseCalculation} handleClick={setValue} disposableIncomeAmount={disposableIncomeAmount}
        incomeAmountForCalculation={incomeAmountForCalculation} setCollapseCalculation = {setCollapseCalculation}
        currencyClass = {getCurrencyClass()}  {...props} />

        {collapseCalculation && (
          <CalculationSection
            showClaculation={collapseCalculation}
            handleClick={setValue}
            disposableIncome={disposableIncome}
            disposableIncomeAmount={incomeAmountCalculation}
            setCollapseCalculation={setCollapseCalculation}
            currencyClass = {getCurrencyClass()}
            {...props}
          />
        )}

        <div className="Grid">
          <div className="Grid-cell">
            <div className="ButtonBar  ButtonBar--spaceBetween ButtonBar--row-reverse ButtonBar-sm--spaceBetween">
              <button
                type="submit"
                id="disposable-income-submit"
                className="Button"
              >
                <span>{PageData?.EnterDisposableIncomeButtonLabel}</span>
              </button>
              <PageLink
                className="Button Button--gray"
                text={PageData?.CancelDisposableIncomeButtonLabel}
                url={Model?.ChooseYourPlanPageUrl}
              />
            </div>
          </div>
        </div>
      </form>
      </div>
    </div>
  );
};

export default EnterDisposableIncomePageData;
